import { render, staticRenderFns } from "./switchTab.vue?vue&type=template&id=19bba1a0&scoped=true&"
import script from "./switchTab.vue?vue&type=script&lang=js&"
export * from "./switchTab.vue?vue&type=script&lang=js&"
import style0 from "./switchTab.vue?vue&type=style&index=0&id=19bba1a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bba1a0",
  null
  
)

export default component.exports